import { cn } from "@client/utils/cn";
import { formatCurrency } from "@client/utils/formatCurrency";
import { Input } from "@sfc/ui";

export function CurrencyInput({
  className,
  value,
  onValueChange,
  ...rest
}: React.ComponentProps<typeof Input> & {
  onValueChange?: (value: number) => void;
}) {
  return (
    <div className={cn("relative", className)}>
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
        $
      </span>
      <Input
        className="pl-8"
        value={formatCurrency(
          Number.parseInt(value?.toString() || "0", 10),
        ).replace("$", "")}
        onChange={(e) => {
          const numericValue = e.target.value.replace(/[^0-9]/g, "");
          onValueChange?.(Number.parseInt(numericValue, 10) || 0);
        }}
        {...rest}
      />
    </div>
  );
}
